import useCrudFilters, {
  CrudFilters,
} from "../../../../../hooks/useCrudFilters";
import { Button, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { EntitySelectField } from "../../../../general/fields/modules/commons/entitySelectField/entitySelectField";
import { warehouseSchema } from "../../../warehouse/domain/schemas/warehouseSchema";
import { TableFilters } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFilterInputWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";
import { TableFiltersWrapper } from "../../../../general/table/modules/commons/tableFilters/tableFilters";

export const PathTableFilters = ({
  updateFilter,
  removeFilter,
  getFilter,
  filters,
  resetFilters,
}: CrudFilters) => {
  const searchValue = getFilter("label") as string;
  const warehouseValue = getFilter("warehouse.id");
  const statusValue = getFilter("warehouse.status");
  const { t } = useTranslation("common");

  const warehouseFilters = useCrudFilters({
    searchBy: "SearchByRootWarehouse",
    fields: {},
  });

  return (
    <TableFiltersWrapper>
      <TableFilters>
        <TableFilterInputWrapper md={4}>
          <label>{t("Search")}</label>
          <Form.Control
            type="text"
            placeholder={t("Search by name")}
            value={searchValue ?? ""}
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("label");
              } else {
                updateFilter("label", value);
              }
            }}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={4}>
          <label>{t("Warehouse")}</label>
          <EntitySelectField
            entity={"Warehouse"}
            prefix={"warehouses"}
            onChange={(option) => {
              if (option == null) {
                removeFilter("warehouse.id");
                return;
              }
              const { value } = option as { value: string };
              updateFilter("warehouse.id", value);
            }}
            limit={100}
            clearable={true}
            schema={warehouseSchema}
            filters={warehouseFilters.filters}
            value={warehouseValue}
          />
        </TableFilterInputWrapper>

        <TableFilterInputWrapper md={4}>
          <label>{t("Status")}</label>
          <Form.Select
            onChange={(event) => {
              const value = event.target.value;
              if (value === "") {
                removeFilter("warehouse.status");
              } else {
                updateFilter("warehouse.status", value === "1");
              }
            }}
            value={`${statusValue ?? ""}`}
          >
            <option value={""}>{"- " + t("All") + " -"}</option>
            <option value={0}>{t("Inactive")}</option>
            <option value={1}>{t("Active")}</option>
          </Form.Select>
        </TableFilterInputWrapper>
      </TableFilters>

      {filters?.fields && Object.keys(filters.fields).length > 0 && (
        <Button
          onClick={resetFilters}
          size={"sm"}
          className="reset-filters"
          variant="light"
        >
          {t("Reset filters")}
        </Button>
      )}
    </TableFiltersWrapper>
  );
};
